import styles from './FJTextToImageLeft.module.less';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJTextToImageStylesContainer from '../container/FJTextToImageStylesContainer';
import FJTextToImagePromptContainer from '../container/FJTextToImagePromptContainer';
import FJTextToImageModelsContainer from '../container/FJTextToImageModelsContainer';
import FJTextToImageRatioContainer from '../container/FJTextToImageRatioContainer';
import FJTextToImageGenerateNumberContainer from '../container/FJTextToImageGenerateNumberContainer';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';

const FJTextToImageLeft = ({ generate, taskStatus, freeNumCreation, isProjectLoading, useCredit, creditNumber }) => {
    return (
        <FJAppLeft>
            <FJVerticalScroller>
                <FJTextToImagePromptContainer id='textToImagePrompt' />
                <div style={{ paddingTop: '20px' }}>
                    <FJTextToImageStylesContainer id='textToImageStyle' />

                    <FJTextToImageModelsContainer />

                    <FJTextToImageRatioContainer />

                    <FJTextToImageGenerateNumberContainer />
                </div>
            </FJVerticalScroller>

            <FJGenerateButton
                className={styles.generate_btn}
                onClick={generate}
                taskStatus={taskStatus}
                isFree={freeNumCreation > 0 && useCredit > creditNumber}
                freeNumCreation={freeNumCreation}
                useCredit={useCredit}
                isProjectLoading={isProjectLoading}
                isShowUsageDetail={true}
                id='textToImageBtn'
            />
        </FJAppLeft>
    );
};

FJTextToImageLeft.propTypes = {
    generate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    useCredit: PropTypes.number,
    creditNumber: PropTypes.number,
};

export default FJTextToImageLeft;
